// extracted by mini-css-extract-plugin
export default {"loaderPageModal":"loader_loaderPageModal__0IiqG","gbBlur":"loader_gbBlur__iHjAb"};